import { motion } from "framer-motion";
import React from "react";
import { Row } from "react-bootstrap";
import { scrollReveal } from "../../animation";
import { useScroll } from "./useScroll";
import CodersRankActivity from "@codersrank/activity";

window.customElements.define("codersrank-activity", CodersRankActivity);

const GitHub = () => {
  const [element, controls] = useScroll();
  return (
    <div id="skills" className="skills-section">
      <motion.div
        variants={scrollReveal}
        ref={element}
        animate={controls}
        className="container"
      >
        <div className="heading-section">
          <h1>
            <span className="chonburi-font green-text">Social</span> Profiles
          </h1>
        </div>
        <Row>
          {/* <codersrank-activity
            username="TejasSheth104"
            legend="true"
            tooltip="true"
          ></codersrank-activity> */}
          {/* <br /> */}
          {/* <img
            src="https://activity-graph.herokuapp.com/graph?username=TejasSheth104&theme=dark&hide_border=true&ring=000000&background=ffffff"
            alt="GitHub Activity Graph"
            width="100%"
          />
          <br />
          <br /> */}
          {/* <img
            src="https://github-readme-stats.vercel.app/api?username=TejasSheth104&bg_color=30,e96443,904e95&title_color=fff&text_color=fff"
            width="45%"
            alt="Tejas's github stats"
          /> */}
          {/* <br />
          <br />
          <br />
          <br />
          <br />
          <br /> */}
          {/* <img
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=TejasSheth104&layout=compact"
            width="40%"
            alt="Tejas's github stats"
          /> */}
          {/* <img
            align="center"
            src="https://github-readme-stats.vercel.app/api/pin/?username=TejasSheth104&repo=ReverseImageQuerying"
            width="60%"
            alt="Tejas Sheth's github stats"
          /> */}

          {/* <p align="center"> */}
          <img
            width="100%"
            src="https://activity-graph.herokuapp.com/graph?username=TejasSheth104&hide_border=true&theme=react-dark&area=true&bg_color=000000&color=ffffff&point=2f80ed&line=ffffff"
            alt="Tejas' Contribution Graph"
          />
          <img
            width="50%"
            // align="left"
            // &show_icons=true
            // &hide_border=true
            // &hide=stars,commits,prs,issues,contribs
            src="https://github-readme-stats.vercel.app/api?username=TejasSheth104&border_color=2f80ed&show_icons=true&bg_color=000000&text_color=ffffff&title_color=ffffff&icon_color=2f80ed&ring=ffffff&background=000000&count_private=true&include_all_commits=true"
            alt="GitHub Stats"
          />
          {/* </Row> */}
          {/* <p>&emsp; &ensp;</p> */}
          {/* <Row> */}
          <img
            width="50%"
            // align="right"
            // src="https://github-readme-streak-stats.herokuapp.com/?user=TejasSheth104&theme=dark"
            src="https://github-readme-streak-stats.herokuapp.com?user=TejasSheth104&theme=dark&ring=000000&background=000000&border=2f80ed&stroke=ffffff&currStreakNum=ffffff&currStreakLabel=ffffff&sideLabels=ffffff&dates=ffffff&sideNums=ffffff&fire=2f80ed"
            alt="GitHub Streak Stats"
          />
          {/* </p> */}
        </Row>
        {/* <Row></Row> */}
      </motion.div>
    </div>
  );
};

export default GitHub;
